import { useContext } from "react";
import { KindOfOrder, NoteType } from "../../../../types/enums";
import AddNoteButton from "../../../common/notes/components/AddNoteButton";
import { RefetchScope, RetailOrderContext } from "../context/RetailOrderContext";
import { useLocation, useNavigate } from "react-router-dom";

export default function RetailOrderAddNoteButton(props: { showNoteType: boolean, changeOrder: boolean }) {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const navigate = useNavigate();
	const location = useLocation();

	const params = {
		showNoteType: props.showNoteType,
		noteTypeID: props.changeOrder ? NoteType.ChangeRequest : NoteType.General,
		kindOfOrder: KindOfOrder.RetailOrder,
		orderID: order.details.retailOrderID,
		onNoteAdded: () => refetchOrder(RefetchScope.Notes),
		onEmailNote: (noteText: string) => {
			navigate(location.pathname + location.search, { state: { messageText: noteText } });	
		}
	};

	return (
		<>
			<AddNoteButton
				caption={props.changeOrder ? "Add Change Order Note" : "Add Retail Order Note"}
				params={params}
			/>
		</>
	)
}
